import React, { useState } from "react";
import { AnimatePresence, motion } from "framer-motion";
import { PlusIcon } from "lucide-react";
import { Section, SectionHeading } from "../Section";
import { CTAButton } from "../CTAButton";
import { faqs } from "../../data/landing";
export function FAQ() {
  const [open, setOpen] = useState<number | null>(0);
  return <Section className="bg-cream" data-id="element-151" data-mp="2z3h44e1ijjlp">
      <SectionHeading title="Frequently asked questions" data-id="element-152" data-mp="3mt30yuuexmqj" />

      <div className="mx-auto mt-10 max-w-3xl space-y-3" data-id="element-153" data-mp="3mtl5sfv559a2">
        {faqs.map((f, i) => {
        const isOpen = open === i;
        return <div key={f.q} className="rounded-2xl bg-white ring-1 ring-navy/10" data-id="element-154" data-mp="3d3jhpo2sfqv5" data-mpi={i}>
              <h3 data-id="element-155" data-mp="3i2339ndgz0mz">
                <button type="button" onClick={() => setOpen(isOpen ? null : i)} aria-expanded={isOpen} className="flex w-full items-center justify-between gap-4 px-5 py-5 text-left font-display text-lg font-bold leading-snug text-navy" data-id="element-156" data-mp="3i1kxo04x3a2e">
                  {f.q}
                  <span className={`flex h-8 w-8 shrink-0 items-center justify-center rounded-full transition-[transform,background-color] duration-200 ease-out ${isOpen ? "rotate-45 bg-coral text-white" : "bg-sky-soft text-navy"}`} data-id="element-157" data-mp="20r01r8hm6q0k">
                    <PlusIcon className="h-5 w-5" aria-hidden="true" data-id="element-158" data-mp="25nyq1aelk2qu" />
                  </span>
                </button>
              </h3>
              <AnimatePresence initial={false} data-id="element-159" data-mp="2eiwlao57vrlc">
                {isOpen && <motion.div initial={{
              height: 0,
              opacity: 0
            }} animate={{
              height: "auto",
              opacity: 1
            }} exit={{
              height: 0,
              opacity: 0
            }} transition={{
              duration: 0.22,
              ease: [0.23, 1, 0.32, 1]
            }} className="overflow-hidden" data-id="element-160" data-mp="2tf45hogmkt0m">
                    <div className="space-y-3 px-5 pb-5 text-[16px] leading-relaxed text-ink/80" data-id="element-161" data-mp="u3uq17fksa1e">
                      {f.a.map(p => <p key={p} data-id="element-162" data-mp="1ns0w2ny37s2l">{p}</p>)}
                    </div>
                  </motion.div>}
              </AnimatePresence>
            </div>;
      })}
      </div>

      <div className="mt-12" data-id="element-163" data-mp="1xqq3fmscxu4l">
        <CTAButton label="I'm ready — get instant access" data-id="element-164" data-mp="1xqzvrh0vkddg" />
      </div>
    </Section>;
}